import cn from 'clsx';
import {type ClassValidator, extendTailwindMerge} from 'tailwind-merge';

const customSpacingValidator: ClassValidator = (value) =>
    /^[\d.]+(?:-hw-offset)?$/.test(value) ||
    /^safe-or-[\d.]+$/.test(value) ||
    /^safe-hw-inset-\d+$/.test(value) ||
    value === 'safe-offset-sticky-header';

const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [{text: ['12', '14', '16', '18', '20', '28', '32']}],
            pt: [{pt: ['hw-offset', 'app']}],
            pb: [{pb: ['safe-or', 'app', 'app-menu']}],
        },
        conflictingClassGroups: {
            pt: ['pt'],
            pb: ['pb'],
        },
        theme: {
            spacing: [customSpacingValidator],
        },
    },
});

export const twx = (...props: Parameters<typeof cn>) => twMerge(cn(props));
